export default __webpack_public_path__ + "static/media/GC_11.b050a22d.png";